define('features/overlayGameLauncher/adventureTwo/adventureStaticData',[
    'knockout',
    'underscore'
],
function (ko, _) {

    return function adventureStaticData () {

        var self = this;

        self.belts = [
            {
                name: 'Rope',
                xp: 0,
                color: 'yellow-lighter'
            },
            {
                name: 'White',
                xp: 10,
                color: 'white'
            },
            {
                name: 'Yellow',
                xp: 20,
                color: 'yellow'
            },
            {
                name: 'Red',
                xp: 30,
                color: 'red'
            },
            {
                name: 'Blue',
                xp: 40,
                color: 'blue'
            },
            {
                name: 'Purple',
                xp: 50,
                color: 'purple'
            },
            {
                name: 'Black',
                xp: 60,
                color: 'grey'
            }
        ];

        self.milestones = [
            {
                progress: 25,
                reward: {
                    xp: 200,
                    freespins: 100
                }
            },
            {
                progress: 50,
                reward: {
                    xp: 200,
                    freespins: 100
                }
            },
            {
                progress: 75,
                reward: {
                    xp: 200,
                    freespins: 100
                }
            },
            {
                progress: 25,
                reward: {
                    xp: 200,
                    freespins: 100
                }
            }
        ];

        self.belt = ko.pureComputed(function () {
            var xp = self.xp(),
                belts = self.belts,
                belt = 0,
                i,
                current,
                next;

            for (i = 0; i < belts.length; i++) {
                current = belts[i];
                next = belts[i + 1];

                if (!next) {
                    belt = belts.length - 1;
                    break;
                }

                if (_.inRange(xp, current.xp, next.xp)) {
                    belt = i;
                    break;
                }
            }

            return belt;
        });

        self.beltName = ko.pureComputed(function () {
            var beltLevel = self.belt();

            return self.belts[beltLevel].name;
        });

        self.nextBelt = ko.pureComputed(function () {
            var beltLevel = self.belt(),
                beltData = self.belts[beltLevel + 1];

            if (!beltData) {
                return self.belts.length - 1;
            }

            return beltLevel + 1;
        });

        self.nextBeltName = ko.pureComputed(function () {
            var beltLevel = self.nextBelt();

            return self.belts[beltLevel].name;
        });

        self.levelUpProgression = ko.pureComputed(function () {
            var belts = self.belts,
                beltLevel = self.belt(),
                xp = self.xp(),
                currentBeltData = belts[beltLevel],
                nextBeltData = belts[beltLevel + 1];

            if (!nextBeltData) {
                return 0;
            }

            return ((xp - currentBeltData.xp) / (nextBeltData.xp - currentBeltData.xp)) * 100;
        });

        self.levelUpProportion = ko.pureComputed(function () {
            var belts = self.belts,
                beltLevel = self.belt(),
                xp = self.xp(),
                currentBeltData = belts[beltLevel],
                nextBeltData = belts[beltLevel + 1];

            if (!nextBeltData) {
                return null;
            }

            return {
                current: (xp - currentBeltData.xp),
                next: nextBeltData.xp
            };
        });

    };
});

